export default {
  field: {
    label: 'Categoria fiscale',
    placeholder: 'Nessuna categoria fiscale',
    unlinked_hint:
      "Senza una, un prodotto usa l'aliquota della categoria di menu o l'aliquota standard del ristorante.",
    default_hint: 'Se salvato senza, riceve la categoria fiscale predefinita del menu.',
  },
  empty: {
    hint: 'Nessuna categoria fiscale — aggiungine una qui sotto.',
    read_only_hint: 'Non sono ancora state configurate categorie fiscali.',
  },
  option: {
    varies_by_channel: '(varia in base al canale)',
  },
  load_error:
    'Impossibile caricare le categorie fiscali — il collegamento e lo scollegamento sono disabilitati finché non viene caricato.',
  create: {
    name_placeholder: 'Nome nuova categoria',
    rate_placeholder: 'Aliquota %',
    button: 'Aggiungi categoria fiscale',
  },
  toasts: {
    create_error: 'Impossibile creare la categoria fiscale.',
  },
};
